
import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Idle } from '@ng-idle/core';
import { Keepalive } from '@ng-idle/keepalive';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../shared/config/app-config';
import { SessiontempComponent } from '../sessiontemp/sessiontemp.component';
import { Errors, ShowHideInput, UserService } from '../shared';
import { User } from '../shared/models';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'auth-page',
  templateUrl: './pauth.component.html',
  styleUrls: ['./style.css']
})
export class PAuthComponent implements OnInit {
  signup: boolean = false;
  session: boolean = false;
  authType: string = '';
  title: string = '';
  errors: Errors = new Errors();
  isSubmitting = true;
  authForm: FormGroup;
  type: string = 'email';
  public idletime: any = environment.idletime;
  public setidletime: any = environment.timeset;
  @ViewChild(ShowHideInput) input: ShowHideInput;
  show = false;
  username: any = "";
  password: any = "";
  remember: any = false;
  code: any;
  ipBlocked = true;
  ipBlockedDetails: any;
  public name: any;
  public css: any;
  public csslogo: any;
  public cssbgimg: any;
  public apiurl: any = environment.api_url;
  setmask: string;
  language: any;
  helpDeskNo: any;
  captcharequired: boolean = false;
  captcha: string = '';
  previousEmail = '';
  /* username:any ="hospital@solvedge.in";
  password:any ="demo";
 */
  languageConfig = {
    "multiLanguageRequired" : false,
    "languages": []
  };
  languageSubscription : Subscription;
  PrefLanguageGet = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private userService: UserService,
    private fb: FormBuilder,
    private dialog: MatDialog,
    private idle: Idle,
    private keepalive: Keepalive,
    private _cookieService: CookieService,
    private translate: TranslateService
  ) {
    // set en as default
    this.userService.setCurrentLanguage(this.userService.LoginDefaultLanguage);
    // use FormBuilder to create a form group
    this.authForm = this.fb.group({
      'username': ['', Validators.required],
      'code': [''],
      'captcha': [null],
      'password': ['', Validators.required],
      'remember': [''],
      'selectedLang': [this.userService.LoginDefaultLanguage]
    });

    this.remember = this._cookieService.get('remember');
    if (this._cookieService.get('username')) {
      let username = this._cookieService.get('username').split('-')
      if (username.length > 1) {
        this.code = username[0]
        this.username = username[1]
        this.type = "number"
        this.checkphone(this.code)
      } else
        this.username = this._cookieService.get('username');
      this.checkCaptcha(this.username);
      this.getPreferredLanguage(this.username);
      this.previousEmail = this.username;
    }
  }
  public imageURL: string = environment.cloudeImageURL;
  public CurrentUser: User;


  ngOnInit() {

    if (navigator.userAgent.search("iPhone") != -1 && location.href.search("changepassword") == -1) {
      this.router.navigateByUrl('/appstore')
    }


    this.route.params.subscribe(params => this.name = params);

    this.userService.getclient(this.name.name).subscribe(css => {

      this.css = css;
      this.csslogo = this.css.logo;
      this.cssbgimg = this.css.bgimg;
      this.language = this.css.language;
      this.helpDeskNo = this.css.helpDeskNo
    });


    this.userService.currentUser.subscribe(
      (userData) => {
        this.CurrentUser = userData;
      }
    )

    this.route.params.subscribe(params => this.name = params);

    this.userService.getclient(this.name.name).subscribe(css => {

      this.css = css;
      this.csslogo = this.css.logo;
      this.cssbgimg = this.css.bgimg;
    });
    if (window.localStorage['session']) {
      this.session = true;
    }
    if (environment.ipBlocked) {
      this.userService.getIPAccess().subscribe(data => {
        this.ipBlockedDetails = data;
        //this.ipBlockedDetails.allowsite =   "no";

        if (this.ipBlockedDetails.allowsite == "no")
          this.ipBlocked = false;
        else
          this.ipBlocked = true;
      },
        err => {
          this.errors = err;
        }
      );
    }
    else {
      this.ipBlocked = true;
    }

    //show selected language
    this.authForm.get('selectedLang')?.valueChanges.subscribe((language: string) => {
      if (language) {
        sessionStorage.setItem("langChangedByUser", "true");
        localStorage.setItem("selectedLanguage", language);
        this.userService.defaultLang = language;
        this.translate.use(language);
      }
    });
  }
  toggleShow(event, id, inputid) {
    this.show = !this.show;

    if (this.show) {
      $(`#${id}`).removeClass('fa-eye')
      $(`#${id}`).addClass('fa-eye-slash')
      let input = $(`#${inputid}`);
      input.attr('type', 'text')
    }
    else {
      $(`#${id}`).removeClass('fa-eye-slash')
      $(`#${id}`).addClass('fa-eye')
      let input = $(`#${inputid}`);
      input.attr('type', 'password')

    }
  }
  progressBarPopup: MatDialogRef<SessiontempComponent>;
  showloader: boolean = false
  submitForm(type) {
    this.showloader = true
    this.isSubmitting = true;
    this.errors = new Errors();
    if (this.authForm.value.captcha == null) {
      this.checkCaptcha(this.authForm.value.username)
      this.showloader = false
      return
    }
    if (this.authForm.value.code) {
      this.authForm.value.username = this.authForm.value.code + '-' + this.authForm.value.username
    }
    if(!this.PrefLanguageGet) {
      this.getPreferredLanguage(this.authForm.value.username,true, type);
      return;
    }
    if (this.authForm.value.remember) {
      this._cookieService.set('username', this.authForm.value.username);
      this._cookieService.set('remember', this.authForm.value.remember);
    } else {
      this._cookieService.deleteAll();
    }
    const credentials = {
      'username': this.authForm.value.username,
      'password': btoa(this.authForm.value.password),
      'captcha': this.authForm.value.captcha,
      'mode': 'direct',
      'usermode': this.userMode,
      'forcelogin': type,
      "language": this.userService.selectedLang()
    }
    localStorage.setItem('userMode', btoa(this.userMode));
    this.userService
      .attemptAuth(credentials)
      .subscribe(

        data => {
          this.showloader = false
          this.captcharequired = false
          window.localStorage.removeItem('session');
          this.idle.setIdle(this.idletime);

          this.idle.setTimeout(this.setidletime);
          if (data.operationStatus.toLowerCase() == 'success')
            this.authForm.reset()
          window.localStorage['plogin'] = this.name.name
        },
        err => {
          this.showloader = false
          err = this.userService.decrypt(err.data)
          if (err.error == 'Multiple Sessions Requested...') {
            this.progressBarPopup = this.dialog.open(SessiontempComponent, {
              hasBackdrop: true,
              disableClose: true
            });
            this.progressBarPopup.componentInstance.doubleSessionActive = true;
            this.progressBarPopup.componentInstance.doubleSessionmessage = err.message

            this.progressBarPopup.afterClosed().subscribe(result => {
              if (result != '' && 'logout' == result) {
                this.errors = new Errors()
                this.isSubmitting = false;
                this.authForm.value.code = '';
                this.checkCaptcha(this.authForm.value.username)
              } else {
                this.submitForm('true')
              }
            });
          } else {
            this.errors = err;
            this.isSubmitting = false;
            this.authForm.value.code = '';
            this.checkCaptcha(this.authForm.value.username)
            if (this.errors.passwordattempt >= 3) {
              this.errors.message = '';
              this.userService.fgotdetails(this.authForm.value.username)
                .subscribe(
                  data => {
                    if (data.item.status1 == 'showingQueNAns') {
                      this.userService.setmail(this.authForm.value.username);
                      window.localStorage['randId'] = data.item.randId
                      if (this.errors.userGroupid != 19 && this.errors.userGroupid != 20)
                        this.router.navigateByUrl('/securityquestion');
                      else
                        this.router.navigateByUrl('/security');
                    }
                  }
                );
            }
            /* this.errors.message.replace('Authentication Failed:','') */
          }
        }
      );



  }
  public customPatterns = { 'A': { pattern: new RegExp('\[a-zA-Z0-9._@+-\]') }, '0': { pattern: new RegExp('\[0-9\]') } };
  Onchange(event) {
    if (event.keyCode != 8) {
      let targetvalue = event.target.value.replace(/[^a-zA-Z0-9._@+]/g, '');
      let keyvalue;
      if (event.key)
        keyvalue = event.key.replace(/[^a-zA-Z0-9._@+]/g, '');
      //if ((isNaN(targetvalue) || targetvalue == '') || (isNaN(keyvalue) || keyvalue == '')) {
      if (isNaN(targetvalue) || targetvalue == '' || isNaN(keyvalue) || keyvalue == '') {
        this.setmask = "A*"
        this.type = 'email'
      } else
        this.type = 'number'
    }
    else {
      if (event.target.value.length <= 0) {
        this.type = 'email'
        this.setmask = "A*"
      }
    }
    if (this.type == 'email')
      this.code = undefined
    else {
      if (this.code == '1' || this.code == undefined || this.code == null) {
        this.code = '1'
        this.checkphone('1')
      }
      else {
        this.checkphone(this.code)
      }
    }

  }
  imgCaptcha: any = '';
  userMode: any = 'c'
  checkCaptcha(event, cameFrom = '') {
    if (event) {
      let targetvalue = event
      if (this.authForm.value.code) {
        targetvalue = this.authForm.value.code + '-' + event
      }
      const credentials = {
        'username': targetvalue
      }
      this.captcha = ''
      this.userService.checkCaptcha(credentials).subscribe(
        data => {
          this.userMode = data?.userMode || 'c';
          if(cameFrom != '' && this.previousEmail != targetvalue)   {     //For only get preferred language when email field focus out 
            this.languageConfig['multiLanguageRequired']=false;
            this.getPreferredLanguage(targetvalue);
            this.previousEmail = targetvalue;
          }
          if (data.status == 'true') {
            this.captcharequired = data.captchaRequired;
            this.imgCaptcha = 'data:image/png;base64,' + data.value;
          } else {
            this.captcharequired = false;
            this.imgCaptcha = ''
            this.authForm.controls['captcha'].setValue('');
          }
        })
      }
    }

    ngOnDestroy() {
      if (this.languageSubscription) {
        this.languageSubscription.unsubscribe();
      }
    }

    patchUserName() {
      if(this.authForm.value.username && this.authForm.value.username.length > 1) {
        this.authForm.patchValue({username:''});
      }
    }
    getPreferredLanguage(emailTargetValue, forSubmit = false, type = false) {
      const credential = {
      'userName': emailTargetValue
    }
    this.PrefLanguageGet = true; //verify for get API
    this.languageSubscription =  this.userService.getLanguageConfig(credential).subscribe(
      langConfigRes => {
        if(langConfigRes && langConfigRes.hasOwnProperty("multiLanguageRequired")) {
          this.languageConfig = langConfigRes;
          if(langConfigRes?.multiLanguageRequired) {
            this.authForm.patchValue({
              "selectedLang": langConfigRes?.preferredlanguage
            });
            setTimeout(() => {
              const cnDropElement = document.getElementById("multilang") as HTMLSelectElement;
              if (cnDropElement) {
                cnDropElement.value = langConfigRes?.preferredlanguage;
              }
            }, 500);
          }
        }
        if(forSubmit) {
          this.submitForm(type);
        }
      }, (error:any) => {
        if(forSubmit) {
          this.submitForm(type);
        }
      });
    }
  checkphone(code) {
    if (this.type == 'number') {
      if (code == "44") {
        this.setmask = '00000 000000'
      } else {
        this.setmask = '(000) 000-0000'
      }
    }
  }
  getFullYear() {
    return new Date().getFullYear();
  }
  setvalue() {
    if (this.type != 'number') {
      return false
    } {
      return true
    }
  }
  signIn() {
    this.router.navigateByUrl(`/signup/${this.name.name}`)
  }

  needHelp() {
    this.userService.loadEmailPopup();
  }
}
